import React from "react";
import { GithubDashboard } from "../../containers";
import "./Computing.css";

const Computing = () => {
  return (
    <div id="computing__container">
      <GithubDashboard />
    </div>
  );
};

export default Computing;
